module.exports = __webpack_public_path__ + "static/media/bell.5d3a1c2d.svg";